var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"dashboardContainer","fluid":"","pa-0":"","fill-height":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }